import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import styles from './styles/login.module.css';

import InputField from './InputField';
import Button from '../common-women/Button';
import {ReactComponent as Logo} from '../../assets/demo/logo.svg';

export default function Login({ response, error, loading, handleSubmit }) {
    const navigate = useNavigate();

    const initialLoginForm = {
        userId: '',
        password: '',
        userIdError: false,
        passwordError: false,
        passwordMessage: '',
    };

    const [loginForm, setLoginForm] = useState(initialLoginForm);

    const changeInput = (e) => {
        const { name, value } = e.target;
        setLoginForm({
            ...loginForm,
            [name]: value
        });
    };

    const handleEnter = (e) => {
        if (e.key === 'Enter' && loginForm.userId && loginForm.password) {
            handleSubmit(loginForm);
        }
    };

    const getBtnStyle = () => {
        const isActive = loginForm.userId && loginForm.password;

        return {
            backgroundColor: isActive ? '#825DFC' : '#A9A9AE',
            disabled: isActive ? '' : 'disabled'
        };
    };

    useEffect(() => {
        if (!loading && response) {
            setLoginForm(initialLoginForm);
            navigate('/');
        }

        if (!loading && error && error.code === 401) {
            setLoginForm({
                ...loginForm,
                userIdError: true,
                passwordError: true,
                passwordMessage: '아이디 또는 비밀번호를 잘못 입력했습니다. 다시 시도해주세요.'
            })
        }

        if (!loading && error && error.code === 500) {
            setLoginForm({
                ...loginForm,
                userIdError: false,
                passwordError: false,
                passwordMessage: '로그인 중 오류가 발생했습니다. 문제가 지속되면 관리자에게 문의해주세요.'
            })
        }
    }, [response, error, loading]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} onKeyDown={handleEnter}>
                <div className={styles.boxLogo}>
                    <Logo className={styles.logo} />
                    <p>Data Assistant Reinforced Via Intelligent System</p>
                </div>
                <div className={styles.boxInput}>
                    <InputField
                        type='userId'
                        text='아이디'
                        placeholder='아이디를 입력해 주세요'
                        name='userId'
                        value={loginForm.userId}
                        error={loginForm.userIdError}
                        handleChange={changeInput}
                    />
                    <InputField
                        type='password'
                        text='비밀번호'
                        placeholder='비밀번호를 입력해 주세요'
                        name='password'
                        value={loginForm.password}
                        error={loginForm.passwordError}
                        message={loginForm.passwordMessage}
                        handleChange={changeInput}
                    />
                </div>
                <Button 
                    text='로그인'
                    width='100%'
                    height='52px'
                    padding='14px 190px'
                    borderRadius='5px'
                    fontSize='20px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={loginForm.userId && loginForm.password ? () => handleSubmit(loginForm) : null}
                    {...getBtnStyle()}
                />
            </div>
            <Button
                text='비밀번호 변경'
                width='fit-content'
                padding='0 0 3px 0'
                height='fit-content'
                fontSize='18px'
                fontWeight='500'
                textColor='#825DFC'
                onClick={() => navigate('/auth/password')}
                style={{ borderBottom: '1px solid #825DFC' }}
            />
        </div>
    );
}
